import { Record } from 'immutable';

const DeltaValueRecord = Record({
  diff: 0,
  diffPercentage: null,
  endAccountingDate: null,
  endSnapshotCreationDate: null,
  endValue: null,
  source: null,
  startAccountingDate: null,
  startSnapshotCreationDate: null,
  startValue: null,
  type: null,
});

export default class DeltaValue extends DeltaValueRecord {
  static deserialize(jsonObject = {}) {
    return new DeltaValue(jsonObject);
  }
}
